module.exports = __webpack_public_path__ + "838ee18710628fcaedbde6f15b02b07b.png";